import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=5761a7b7&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dev.pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5761a7b7', component.options)
    } else {
      api.reload('5761a7b7', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=5761a7b7&", function () {
      api.rerender('5761a7b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Gallery.vue"
export default component.exports